/* eslint-disable */
import TermPage from '../../../components/pages/termPage'

const Term = ({ className }) => {
   return (
      <TermPage className={className} currentKey="term" />
   )
}
export default Term